module.exports = __webpack_public_path__ + "img/Roboto-Regular.379f259e.svg";